'use strict';
Object.defineProperty(exports, '__esModule', { value: true });
var prefix = 'fast';
var iconName = 'boombox';
var width = 640;
var height = 512;
var aliases = [128254];
var unicode = 'f8a5';
var svgPathData = 'M72 0L64 0l0 8 0 152-48 0L0 160l0 16L0 496l0 16 16 0 608 0 16 0 0-16 0-320 0-16-16 0-48 0L576 8l0-8-8 0L72 0zM560 160l-112 0 0-24 0-8-8 0-48 0-8 0 0 8 0 24-32 0 0-24 0-8-8 0-48 0-8 0 0 8 0 24-32 0 0-24 0-8-8 0-48 0-8 0 0 8 0 24L80 160 80 16l480 0 0 144zM72 176l128 0 48 0 48 0 48 0 48 0 48 0 128 0 56 0 0 320L16 496l0-320 56 0zm328-32l32 0 0 16-32 0 0-16zm-64 16l-32 0 0-16 32 0 0 16zm-96-16l0 16-32 0 0-16 32 0zm-64 96a96 96 0 1 1 0 192 96 96 0 1 1 0-192zm0 208a112 112 0 1 0 0-224 112 112 0 1 0 0 224zM368 336a96 96 0 1 1 192 0 96 96 0 1 1 -192 0zm208 0a112 112 0 1 0 -224 0 112 112 0 1 0 224 0z';

exports.definition = {
  prefix: prefix,
  iconName: iconName,
  icon: [
    width,
    height,
    aliases,
    unicode,
    svgPathData
  ]};

exports.faBoombox = exports.definition;
exports.prefix = prefix;
exports.iconName = iconName;
exports.width = width;
exports.height = height;
exports.ligatures = aliases;
exports.unicode = unicode;
exports.svgPathData = svgPathData;
exports.aliases = aliases;